module.exports = __webpack_public_path__ + "img/Anna.7ad72d82.png";